import { Empty, Image } from 'antd';
import React from 'react';
import InvitationEmpty from 'assets/img/empty/invitation.svg';
import styled from 'styled-components';

const Container = styled.div`
  margin-top:100px;
  h3 {
    color: #0c91c4;
    text-align: center;
    font-family: Roboto;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.36px;
  }
`;

const StyledEmpty = styled(Empty)`
  margin-top: 60px;
  .ant-empty-image {
    height: auto;
  }
`;
const Description = styled.p`
  padding-top: 60px;
  color: var(--text-text-400, #4e5a71);
  text-align: center;
  width: 366px;
  margin: auto;
  /* Body/Body 1 - Regular */
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px; /* 118.75% */
  letter-spacing: 0.08px;
`;
const InvitationExpired = () => {
  return (
    <Container>
      <h3>Invitation Invalid</h3>
      <StyledEmpty
        image={<Image preview={false} width={200} src={InvitationEmpty} />}
        description={
          <Description>
            The invitation is expired. You may contact with the sender and ask about resending the
            invitation.{' '}
          </Description>
        }
      />
    </Container>
  );
};
export default InvitationExpired;
